import { dashboardCoraDataResolver } from './pages/dashboard/dashboad-cora.resolver';
import { createCoraFormDataResolver } from './pages/create-cora/create-cora.resolver';
import { listCoraResolver } from './pages/list-cora/list-cora.resolver';
import { detailCoraResolver } from './pages/detail-cora/detail-cora.resolver';
import { pendingCoraResolver } from './pages/pending-cora/pending-cora.resolver';
import { detailAgentResolver } from './pages/detail-agent/detail-agent.resolver';
import { createAgentFormDataResolver } from './pages/create-agent/create-agent.resolver';
import { Route } from '@angular/router';
import { roleGuard } from '@/core/guards/role.guard';
import {
  CORA_DASHBOARD_ROLES,
  CORA_LIST_ROLES,
  CORA_PENDING_ROLES,
  CORA_CREATE_ROLES,
  CORA_MY_CORAS_ROLES,
  CORA_VIEWERS,
} from '@/core/constants/access-roles';

export const coraRoutes: Route = {
  path: 'cora',
  children: [
    {
      path: 'dashboard',
      canActivate: [roleGuard([...CORA_DASHBOARD_ROLES])],
      resolve: { dashboardCoraData: dashboardCoraDataResolver },
      loadComponent: () =>
        import('./pages/dashboard/dashboard-cora.component').then((m) => m.DashboardCoraComponent),
    },
    {
      path: 'create',
      canActivate: [roleGuard([...CORA_CREATE_ROLES])],
      resolve: { formData: createCoraFormDataResolver },
      loadComponent: () =>
        import('./pages/create-cora/create-cora.component').then((m) => m.CreateCoraComponent),
    },
    {
      path: 'list',
      canActivate: [roleGuard([...CORA_LIST_ROLES])],
      resolve: { listData: listCoraResolver },
      loadComponent: () =>
        import('./pages/list-cora/list-cora.component').then((m) => m.ListCoraComponent),
    },
    {
      path: 'pending',
      canActivate: [roleGuard([...CORA_PENDING_ROLES])],
      resolve: { agents: pendingCoraResolver },
      loadComponent: () =>
        import('./pages/pending-cora/pending-cora.component').then((m) => m.PendingCoraComponent),
    },
    {
      path: 'agent/create',
      canActivate: [roleGuard([...CORA_CREATE_ROLES])],
      resolve: { formData: createAgentFormDataResolver },
      loadComponent: () =>
        import('./pages/create-agent/create-agent.component').then((m) => m.CreateAgentComponent),
    },
    {
      path: 'agent/:id',
      canActivate: [roleGuard([...CORA_VIEWERS])],
      resolve: { agent: detailAgentResolver },
      loadComponent: () =>
        import('./pages/detail-agent/detail-agent.component').then((m) => m.DetailAgentComponent),
    },
    {
      path: 'my-coras',
      canActivate: [roleGuard([...CORA_MY_CORAS_ROLES])],
      loadComponent: () =>
        import('./pages/mes-coras/mes-coras.component').then((m) => m.MesCoras),
    },
    {
      path: ':id',
      canActivate: [roleGuard([...CORA_VIEWERS])],
      resolve: { cora: detailCoraResolver },
      loadComponent: () =>
        import('./pages/detail-cora/detail-cora.component').then((m) => m.DetailCoraComponent),
    },
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'dashboard',
    },
  ],
};
